import * as functions from './functions';

(function($){

    $(document).on('ready', function(){

        // Set cart variables for existing cart
        var existingMembershipCart = functions.getCookie(functions.membershipCartCookieName);
        var existingDigitalAdvertisingCart = functions.getCookie(functions.digitalAdvertisingCartCookieName);

        if ( existingMembershipCart != null ) {
            // Add website_membership membership items to visitor cart
            existingMembershipCart.items["website_membership"] = functions.items.website_membership;
            functions.setMembershipCart(existingMembershipCart);
            $('.menu-item.cart-link').show();
        } else {
            functions.setDefaultSelections();
        }
        if ( existingDigitalAdvertisingCart != null ) {
            functions.setDigitalAdvertisingCart(existingDigitalAdvertisingCart);
            if (functions.getCookie('lastCart') != null && functions.getCookie('lastCart') === 'digitalAdvertising') {
                var cartHref = $('.menu-item.cart-link a').attr('href');
                $('.menu-item.cart-link a').attr('href', cartHref + '?for=digital_advertising');
            }
            $('.menu-item.cart-link').show();
        }

        // Don't run all these calculations unless we're actually on a cart page.
        if ($('body.page-sign-up, body.page-cart').length <= 0) {
            return;
        }

        if (functions.isDigitalAdsCheckout()) {
            $('.scrollTo[href="#membership-signup_options"]').attr('href', '#membership-signup_time-for-growth');
            
            const urlParams = new URLSearchParams(window.location.search);
            
            if (urlParams.get('for') === 'digital_advertising') {
                
                var targetSection = $('#membership-signup_time-for-growth');
                
                if (targetSection.length) {
                    setTimeout(function(){
                        $('html, body').animate({
                            scrollTop: targetSection.offset().top
                        }, 500);
                    }, 500);
                }
            }

            $('.basic-membership-section').hide();
            $('.digital-advertising-section').show();
            $('.checkout-link').attr('href', $('.checkout-link').attr('href')+'?for=digital_advertising');
        }

        $('.global-notification').on('click', '.close', function(){
            $('.global-notification').removeClass('visible');
        });

        $('#manageAddons').on('show.bs.modal', function (event) {
            var editSKU = $(event.relatedTarget).data('edit-sku');
            $('#manageAddons #editAddon-'+editSKU).show();
        });
        $('#manageAddons').on('hidden.bs.modal', function () {
            $('#membership-signup_choose-membership-details > div').hide();
        })

        functions.setPreviousCartHeight($('#membership-signup_slideup-cart').outerHeight());

        for(var group in functions.getCart().items) {
            if (functions.getCart().items.hasOwnProperty(group)) {
                var skus = functions.getCart().items[group];
                for (var sku in skus) {

                    // Mark all buttons related to items in cart as selected.
                    //jQuery('button[data-sku="'+sku+'"]').addClass('focus selected');
                    jQuery('input[type="number"][data-sku="'+sku+'"]').val(skus[sku].quantity);

                    // Mark any "radio toggle" selections. Clicking these will remove the item from the cart.
                    jQuery('input.radioToggle[data-sku="'+sku+'"]').parent('label').addClass('focus selected').find('span').text('Remove');

                    // Set radio input selections website_membershipd on items in cart, then ad visual classes to parent label elements
                    jQuery('input[type="radio"][data-sku="'+sku+'"], input[type="checkbox"][data-sku="'+sku+'"]').prop('checked', true);
                    jQuery('input[type="checkbox"][data-sku="'+sku+'"]').parent('label').addClass('active').parents('li').addClass('selected');
                    jQuery('[data-group="'+group+'"]:checked').parent('label').addClass('focus selected');

                    // If this is the 'eCommerce' sku, mark the button as selected and de-select the 'no eCommerce' button
                    if (sku === "eCommerce") {
                        jQuery('label[for="no_eCommerce"]').removeClass('focus selected');
                    }
                }
            }
        }
        
        
        functions.calculateCartTotals();

        $('input[type="number"]').on('change', function(){
            var sku = $(this).data('sku');
            var group = $(this).data('group');
            var quantity = $(this).val();
            var prevQuantity = 0;

            if (sku == null) {
                return;
            }

            if (functions.getCart().items[group][sku] != null) {
                prevQuantity = functions.getCart().items[group][sku].quantity;
            }

            var qty_change = Math.abs(prevQuantity - quantity);

            if (quantity > prevQuantity) {
                functions.addItemToCart(sku, group, qty_change);
                if ( typeof fbq === 'function' ) {
                    fbq('track', 'AddToCart', {content_ids: [sku], contents: [{'id': sku, 'quantity': qty_change}]});
                }
            } else {
                
                functions.removeItemFromCart(sku, group, qty_change);
                
            }
            
        });

        $('body').on('click', '.signup-checkbox', function(e){
            var button = $(this),
                input = button.find('input'),
                name = input.attr('name'),
                sku = input.data('sku'),
                group = input.data('group');
            
            setTimeout(function(){
                if (input.is(':checked')) {
                    functions.addItemToCart(sku, group, 1);
                    $("[name='"+name+"']").parents('.signup-checkbox').addClass('active selected focus');
                    $("[name='"+name+"']").parents('li').addClass('selected');
                } else {
                    functions.removeItemFromCart(sku, group);
                    $("[name='"+name+"']").prop('checked', false);
                    $("[name='"+name+"']").parents('.signup-checkbox').removeClass('active selected focus');
                    $("[name='"+name+"']").parents('li').removeClass('selected');
                }
            }, 100);
        });

        $('.confirm-fb-skip').on('click', function(e){
            e.preventDefault();
            $.confirm({
                theme: 'supervan',
                title: '',
                content: '<p class="text-center">Friendly reminder that this option is for those with existing Facebook ad campaigns.</p>',
                buttons: {
                    ok: {
                        text: "Ok, thanks!",
                        action: function() {
                            functions.switchStep('#facebookAdsModal', 2);
                            $('#facebookAdsModal .modal-panel-1').hide();
                            $('#facebookAdsModal .modal-panel-2').show();
                        }
                    },
                    buildCampaignInstead: {
                        text: "Build a campaign",
                        action: function() {
                            functions.switchStep('#facebookAdsModal', 1);
                            $('#facebookAdsModal .modal-panel-1').hide();
                            $('#facebookAdsModal .modal-panel-2').show();
                        }
                    }
                },
                useBootstrap: false,
                boxWidth: '375px',
                backgroundDismiss: true
            })
        });

        $('#toggle-slide-cart').on('click', function(){

            if ($('#cart-items').outerHeight() <= 0) {
                functions.openCart();
                $('#toggle-slide-cart i').css({transform:'rotate(180deg)'});
            } else {
                functions.closeCart();
                $('#toggle-slide-cart i').css({transform:'rotate(0deg)'});
            }

        });

        $('#contentCreationItems label').on('click', function(e){

            e.preventDefault();

            var sku = $(this).find('input').data('sku');
            var group = $(this).find('input').data('group');

            $('#contentCreationItems label').removeClass('focus selected');
            $('#contentCreationItems label span').text('Add to cart');

            functions.clearGroupFromCart('contentCreation');

            if($(this).find('input').prop('checked')) {
                $(this).find('input').prop('checked', false);
                $(this).find('span').text('Add to cart');
                $(this).removeClass('focus selected');
            } else {
                functions.addItemToCart(sku, group, 1);
                $(this).find('input').prop('checked', true);
                $(this).find('span').text('Remove');
                $(this).addClass('focus selected');
            }

        });

        $('#eCommerceSelect input').on('click', function(e){

            var sku = $(this).data('sku') != null ? $(this).data('sku') : $(this).data('remove-sku');
            var group = $(this).data('group');

            $('#eCommerceSelect label').removeClass('focus selected');
            
            if($(this).val() === 'yes') {
                functions.addItemToCart(sku, group, 1);
                functions.deleteCookie('selectedNoEcommerce');
            } else {
                functions.setCookie('selectedNoEcommerce', 'yes', 1);
                functions.removeItemFromCart(sku, group);
            }

            $(this).parent().addClass('focus selected');

        });

        $('#membership-signup_choose-support-hours label').on('click', function(e){

            e.preventDefault();
            var sku = $(this).find('input').data('sku');
            var group = $(this).find('input').data('group');
            var toggle = !$(this).hasClass('selected');

            $('#membership-signup_choose-support-hours label').removeClass('focus selected');

            functions.clearGroupFromCart('support');

            if (toggle) {
                functions.addItemToCart(sku, group, 1);
                $(this).find('input').prop('checked', true).trigger('change');
                $(this).addClass('focus selected');
            } else {
                $(this).find('input').prop('checked', false).trigger('change');
            }

        });

        $('#googleAdwordsModal .cart-btn').on('click', function(){

            var clickedButton = $(this);
            var sku = clickedButton.data('sku');
            var remove_sku = clickedButton.data('remove-sku');
            var group = clickedButton.data('group');
            
            if (sku != null) {
                functions.addItemToCart(sku, group, 1);
                $('.signup-checkbox input[data-sku="'+sku+'"]').prop('checked', true).parent('label').addClass('selected active').parents('li').addClass('selected');
            } else if (remove_sku != null) {
                functions.removeItemFromCart(remove_sku, group);
                $('.signup-checkbox input[data-sku="'+remove_sku+'"]').prop('checked', false).parent('label').removeClass('selected active').parents('li').removeClass('selected');
            }

            setTimeout(function(){
                currentStep = clickedButton.data('next-step');
                functions.switchStep('#googleAdwordsModal', currentStep);
            }, 500);

        });

        $('#googleAdwords-manage-btn').on('click', function(){
            functions.switchStep('#googleAdwordsModal', 2);
        });

        $('#facebookAdsModal [data-step]').on('click', function(){
            functions.switchStep('#facebookAdsModal', $(this).data('step'));
        })

        $('#facebookAdsModal .cart-btn').on('click', function(){

            var clickedButton = $(this);
            var sku = clickedButton.data('sku');
            var remove_sku = clickedButton.data('remove-sku');
            var group = clickedButton.data('group');
            
            if (sku != null) {
                functions.addItemToCart(sku, group, 1);
                $('.signup-checkbox input[data-sku="'+sku+'"]').prop('checked', true).parent('label').addClass('selected active').parents('li').addClass('selected');
            } else if (remove_sku != null) {
                functions.removeItemFromCart(remove_sku, group);
                $('.signup-checkbox input[data-sku="'+remove_sku+'"]').prop('checked', false).parent('label').removeClass('selected active').parents('li').removeClass('selected');
            }

            setTimeout(function(){
                currentStep = clickedButton.data('next-step');
                functions.switchStep('#facebookAdsModal', currentStep);
            }, 500);

        });

        $('.modal-panel-switch').on('click', function(e){
            e.preventDefault();
            $(this).parents('.modal').find('.modal-panel').hide();
            $(this).parents('.modal').find('.modal-panel-'+$(this).data('panel')).show();
        });

        /**
         * Multi-step forms
         * @url https://www.codeply.com/go/PPzgkioUj2/bootstrap-step_by_step-form-example
         */
        if ($('.stepwizard').length > 0) {

            var navListItems = $('div.setup-panel div a'),
                allSteps = $('.step-content'),
                allNextBtn = $('.nextBtn'),
                allPrevBtn = $('.prevBtn'),
                currentStep = 1;

            allSteps.hide();

            navListItems.on('click', function (e) {
                e.preventDefault();
                var $item = $(this);

                if (!$item.hasClass('disabled')) {
                    functions.switchStep('#' + $item.parents('.modal').attr('id'), $item.text());
                }
            });
            
            allPrevBtn.on('click', function(e){
                e.preventDefault();
                var goToStep = $(this).data('step');
                $('.step-pricing').hide();
                functions.switchStep('#' + $(this).parents('.modal').attr('id'),goToStep);
            });

            allNextBtn.on('click', function(){
                var curStep = $(this).closest(".step-content"),
                    curStepBtn = curStep.attr("id"),
                    nextStepWizard = $('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().next().next('.stepwizard-step').children("a"),
                    isValid = true;
                    currentStep++;
                    $('.step-pricing').hide();
                    $('.step-'+currentStep+'-pricing').show();

                if (isValid)
                    nextStepWizard.removeAttr('disabled').trigger('click');
            });

            $('div.setup-panel div a.btn-primary').trigger('click');

        }

        $('#manageAddons input').on('change', function(){
            setTimeout(function(){
                functions.cy_notification('success', 'Membership Preferences Saved', 2000);
            }, 500);
        })

        $('.checkout-link').on('click', function(e){
            e.preventDefault();
            if ( typeof fbq === 'function' ) {
                fbq('track', 'InitiateCheckout');
            }
            var destination = $(this).attr('href');
            setTimeout(function(){
                window.location = destination;
            }, 1500);
        });

    });
})(jQuery);
